import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, Link , NavLink} from 'react-router-dom';

import './New.css';
import Loader from './Loader';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faLink as faLinkIcon, faLock, faFileSignature, faFileContract, faExclamationTriangle, faPhone, faHome } from '@fortawesome/free-solid-svg-icons';
import { faXTwitter, faFacebook, faLinkedin, faInstagram, faYoutube } from "@fortawesome/free-brands-svg-icons";
import CONFIG from "./config";

// Helper to strip HTML tags
const stripHtml = (html) => {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
};

// Extract YouTube video ID
const getYouTubeId = (url) => {
  const regExp = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/;
  const match = url.match(regExp);
  return match ? match[1] : null;
};

const NewDetail = () => {
  const { id } = useParams();
  const [packageData, setPackageData] = useState(null);
  const [selectedMediaIndex, setSelectedMediaIndex] = useState(0);
  const [error, setError] = useState(null);
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(true);
  const [mediaLoading, setMediaLoading] = useState(false);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { title: 'आम्ही कोण आहोत?', path: '/leadership' },
    { title: 'बातम्या आणि ब्लॉग', path: '/news' },
    { title: 'संपर्क करा', path: '/contact' },
  ];

  useEffect(() => {
    const fetchPackage = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${CONFIG.API_BASE_URL}/api/newsblogs/${id}`);
        if (response.data.status === 'success') {
          setPackageData(response.data.package);
          setSelectedMediaIndex(0);
          setError(null);
        } else {
          setError('Package not found.');
        }
      } catch (err) {
        setError('Error fetching data.');
      } finally {
        setLoading(false);
      }
    };
    fetchPackage();
  }, [id]);

  const copyLink = () => {
    const url = window.location.href;
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 1500);
        })
        .catch(() => fallbackCopy(url));
    } else {
      fallbackCopy(url);
    }

    function fallbackCopy(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(textarea);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  };

  if (loading) {
    return (
      <div style={{ padding: 20, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh', flexDirection: 'column' }}>
        <Loader />
        <p style={{ marginTop: 10, fontSize: 20, color: '#FF6F00' }}>लोड होत आहे... कृपया थांबा</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: 20, color: 'red', marginTop: 50 }}>
        <h2>Error</h2>
        <p>{error}</p>
        <Link to="/news">Back to News</Link>
      </div>
    );
  }

  // Prepare media list
  const mediaList = [];
  for (let i = 1; i <= 5; i++) {
    const imgKey = `pakageimage${i}`;
    if (packageData[imgKey]) {
      mediaList.push({
        type: 'image',
        url: `${CONFIG.API_BASE_URL}/public/uploads/packages/${packageData[imgKey]}`
      });
    }
  }
  for (let i = 1; i <= 2; i++) {
    const videoKey = `youtube_link${i}`;
    if (packageData[videoKey]) {
      mediaList.push({ type: 'video', url: packageData[videoKey] });
    }
  }
  const selectedMedia = mediaList[selectedMediaIndex] || null;

  return (
    <>
      {/* Header */}
       <header className="header">
              <div className="nav-container">
                <div className="logo">
                  <Link to="/">
        <img src="https://lokadhikar.in/web.png" alt="PIR Logo" />
      </Link>
      
                </div>
                <nav className="nav-links">
                  {navItems.map((item, index) => (
                    <div key={index} className="nav-item">
                      <NavLink
                        to={item.path}
                        className={({ isActive }) =>
                          isActive ? 'nav-button active' : 'nav-button'
                        }
                      >
                        {item.title}
                      </NavLink>
                    </div>
                  ))}
                </nav>
                <div className="search-language" style={{ position: 'relative' }}>
                  <div
                    style={{
                      position: 'absolute',
                      top: '-19px',
                      left: '16px',
                      fontSize: '22px',
                      color: '#FF6F00',
                      fontFamily: 'Mukta, sans-serif',
                      whiteSpace: 'nowrap',
                      zIndex: 10,
                      pointerEvents: 'none',
                    }}
                  >
                    <span className="lokadhikar-title">महाराष्ट्र लोकाधिकार समिती</span>
                  </div>
                  <div className="pir-search-wrapper"></div>
                </div>
                <button
                  className="mobile-toggle"
                  onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
                >
                  ☰
                </button>
              </div>
              {isMobileMenuOpen && (
                <div className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
                  {navItems.map((item, index) => (
                    <Link
                      key={index}
                      className="mobile-link"
                      to={item.path}
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      {item.title}
                    </Link>
                  ))}
                </div>
              )}
            </header>

      {/* Main content */}
      <div style={{ maxWidth: 1500, margin: '20px auto', padding: '0 20px', display: 'flex', flexDirection: 'column', gap: 20 }}>
        {/* Back + Copy link */}
        <div className="top-actions" style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12, marginTop: 33 }}>
          <Link to="/news" className="button"><FontAwesomeIcon icon={faArrowLeft} /> Back to News</Link>
          <button onClick={copyLink} style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: 16, display: 'flex', alignItems: 'center', gap: 6 }}>
            <FontAwesomeIcon icon={faLinkIcon} style={{ color: '#000', fontSize: 18 }} /> Copy link
          </button>
        </div>
        {copied && <div style={{ textAlign: 'right', fontSize: 14, color: '#28a745' }}>Link copied!</div>}

        {/* Title */}
        <h2 className="package-title" style={{ textAlign: 'center', marginBottom: 15 }}>{packageData?.turename}</h2>

        {/* Social icons + Date */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <div className="news-social-icons" style={{ display: 'flex', gap: 12 }}>
            {[1,2,3,4,5].map((i) => {
              const scoLink = packageData[`sco${i}`];
              if (!scoLink) return null;
              const icons = [faXTwitter, faFacebook, faLinkedin, faInstagram, faYoutube];
              return (
                <a key={i} href={scoLink} target="_blank" rel="noreferrer" style={{ fontSize: 18 }}>
                  <FontAwesomeIcon icon={icons[i-1]} />
                </a>
              );
            })}
          </div>
          <div style={{ fontSize: 14, color: '#333', fontWeight: 500 }}>
            {packageData?.date ? new Date(packageData.date).toLocaleDateString('mr-IN', { day:'numeric', month:'long', year:'numeric'}) : ''}
          </div>
        </div>

        {/* Outer box: Slider + Description */}
        <div className="outer-square" style={{ display: 'flex', gap: 20, border: '2px solid #ddd', borderRadius: 12, padding: 20, background: '#fff', flexDirection: mediaList.length === 0 ? 'column' : 'row', position: 'relative' }}>

          {/* Slider */}
          {mediaList.length > 0 && (
            <div className="slider-section" style={{ flex: '0 0 30%' }}>
              <div className="media-slider-wrapper" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 20 }}>
                <button className="media-nav-button prev-button" onClick={() => {
                  setMediaLoading(true);
                  setTimeout(() => { setSelectedMediaIndex(prev => prev > 0 ? prev -1 : mediaList.length-1); setMediaLoading(false); }, 300);
                }}>‹</button>

                <div className="media-display" style={{ minHeight: 450, flex: '1 1 auto', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }}>
                  {mediaLoading ? <Loader /> :
                    selectedMedia?.type === 'video' ? (
                      <iframe width="100%" height="100%" src={`https://www.youtube.com/embed/${getYouTubeId(selectedMedia.url)}`} title="YouTube video" frameBorder="0" allowFullScreen style={{ borderRadius: 12 }} />
                    ) : selectedMedia?.type === 'image' ? (
                      <img src={selectedMedia.url} alt={packageData.turename} style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: 12 }} />
                    ) : null
                  }
                </div>

                <button className="media-nav-button next-button" onClick={() => {
                  setMediaLoading(true);
                  setTimeout(() => { setSelectedMediaIndex(prev => prev < mediaList.length-1 ? prev+1 : 0); setMediaLoading(false); }, 300);
                }}>›</button>
              </div>

              {/* Thumbnails */}
              <div style={{ display: 'flex', overflowX: 'auto', gap: 10, paddingTop: 10 }}>
                {mediaList.map((media, idx) => (
                  <div key={idx} onClick={() => setSelectedMediaIndex(idx)}
                    style={{ cursor:'pointer', overflow:'hidden', width:80, height:60, borderRadius:8, border: idx===selectedMediaIndex?'2px solid #FF6F00':'1px solid #ccc', boxShadow:'0 2px 6px rgba(0,0,0,0.15)', transition:'all 0.3s ease', flex:'0 0 auto' }}>
                    {media.type==='video' ? (
                      <img src={`https://img.youtube.com/vi/${getYouTubeId(media.url)}/0.jpg`} alt="" style={{ width:'100%', height:'100%', objectFit:'cover', display:'block' }} />
                    ) : (
                      <img src={media.url} alt="" style={{ width:'100%', height:'100%', objectFit:'cover', display:'block' }} />
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Description */}
          <div className="prasstavana-section" style={{ flex: mediaList.length>0?'1 1 70%':'1 1 100%', borderLeft: mediaList.length>0?'2px solid #eee':'none', paddingLeft: mediaList.length>0?20:0 }}>
            <div className="news-description" dangerouslySetInnerHTML={{ __html: packageData.filldesc }} />
          </div>

          {/* Bottom-left social icons */}
          <div className="outer-footer" style={{ position:'absolute', bottom:20, left:20, display:'flex', gap:12 }}>
            <div className="news-social-icons" style={{ display:'flex', gap:8 }}>
              {[1,2,3,4,5].map((i) => {
                const scoLink = packageData[`sco${i}`]; 
                if (!scoLink) return null;
                const icons = [faXTwitter, faFacebook, faLinkedin, faInstagram, faYoutube];
                return <a key={i} href={scoLink} target="_blank" rel="noreferrer"><FontAwesomeIcon icon={icons[i-1]} /></a>;
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="pir-footer">
        <div className="footer-container">
          <div className="footer-left"><img src="/web.png" alt="Logo" className="footer-logo-vertical" /></div>
          <div className="footer-center">
            <div className="footer-links-columns">
              <ul className="footer-links">
                <li><a href="/privacypolicy"><FontAwesomeIcon icon={faLock} /> गोपनीयता धोरण</a></li>
                <li><a href="/signuppolicy"><FontAwesomeIcon icon={faFileSignature} /> नोंदणी धोरण</a></li>
              </ul>
              <ul className="footer-links">
                <li><a href="/termsuse"><FontAwesomeIcon icon={faFileContract} /> वापर अटी</a></li>
                <li><a href="/disclaimer"><FontAwesomeIcon icon={faExclamationTriangle} /> अस्वीकृती</a></li>
              </ul>
            </div>
          </div>
          <div className="footer-right">
            <div className="footer-social">
                                  <a href="https://x.com/Lokadhikar2005?t=n-S1KS-Ao-aj7fmOe-QRxw&s=09"  target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faXTwitter} /></a>
                                  <a href="https://www.facebook.com/groups/2151387758675095/?ref=share&mibextid=NSMWBT" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faFacebook} /></a>
                                 <a href="https://www.linkedin.com/in/lokadhikar-samiti-0537a937a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faLinkedin} /></a>
                                  <a href="https://www.instagram.com/lokadhikar.in?igsh=ZXN0bHpiYm5nMjg=" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faInstagram} /></a>
                                  <a href="https://youtube.com/@lokadhikar-2005?si=cuc0vPRI6NLxhaQs" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faYoutube} /></a>
                                </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="marathi-text">© २०२५ महाराष्ट्र लोकाधिकार समिती – <span className="blue-tex">सर्व हक्क राखीव</span></p>
        </div>
      </footer>

      {/* Right-side fixed icons */}
      <ul className="right-side-icons">
        <li><a href="/" className="icon-link pulse-glow" title="Home"><FontAwesomeIcon icon={faHome} /></a></li>
        <li><a href="tel:+917887779899" className="icon pulse-glow" title="Call Us"><FontAwesomeIcon icon={faPhone} /></a></li>
      </ul>
    </>
  );
};

export default NewDetail;
